import { render } from "./CertificateField.vue?vue&type=template&id=0c2ae7df&scoped=true"
import script from "./CertificateField.vue?vue&type=script&lang=js"
export * from "./CertificateField.vue?vue&type=script&lang=js"

import "./CertificateField.vue?vue&type=style&index=0&id=0c2ae7df&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-0c2ae7df"

export default script